<template>
    <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
        <template v-slot:header>
            <p class="mb-0" style="font-size: 21px">Registrar Item</p>
        </template>
        <b-card-text>
            <b-alert show variant="danger" v-if="errors">
                <ul >
                    <li v-for="(item, index) in errors" :key="index">{{ item }}</li>
                </ul>
            </b-alert>
            <b-tabs content-class="mt-3" justified>
                <b-tab title="Información Básica" active>
                    <ValidationObserver v-slot="{ handleSubmit, invalid }">
                        <b-form @submit.prevent="handleSubmit(updatePriceList)">  
                            <b-row>        
                                <b-col cols="12" md="4">
                                    <ValidationProvider name="codigo" rules="required"  v-slot="{ errors, valid }">
                                        <b-form-group prepend="SL"
                                            label="Código:">
                                            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                                                <template #prepend>
                                                    <b-input-group-text >SL</b-input-group-text>
                                                </template>
                                                <b-form-input
                                                    v-model="update.codigo"
                                                    type="text"
                                                    autocomplete="off"
                                                    required
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    placeholder="Ingrese el código"
                                                ></b-form-input>
                                                <b-form-invalid-feedback>
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <ValidationProvider name="nombre" rules="required|min:3" v-slot="{ errors, valid }">
                                        <b-form-group 
                                            label="Nombre:">
                                            <b-form-input
                                                v-model="update.nombre"
                                                type="text"
                                                autocomplete="off"
                                                required
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                placeholder="Ingrese el nombre"
                                                ></b-form-input>
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <ValidationProvider name="categoria" rules="required" v-slot="{ errors, valid }">
                                        <b-form-group 
                                            label="Selecciona categoria:">
                                            <b-form-select
                                                v-model="update.categoria_id"
                                                :options="categoriesList"
                                                class="mb-3"
                                                value-field="id"
                                                text-field="nombre"
                                                @change="getAttributesListOFCategory"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                >
                                            </b-form-select>
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <b-form-group 
                                        label="Imagen:">
                                        <b-form-file
                                            v-model="imagen"
                                            :state="Boolean(imagen)"
                                            browse-text="Buscar"
                                            accept="image/*"
                                            placeholder="Selecciona una imagen"
                                            drop-placeholder="Arrastre una imagen aqui"
                                        ></b-form-file>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <ValidationProvider name="precio" rules="required" v-slot="{ errors, valid }">
                                        <b-form-group 
                                            label="Precio:">
                                            <b-form-input
                                                v-model="update.precio"
                                                type="number"
                                                step=".01"
                                                autocomplete="off"
                                                required
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                placeholder="Ingrese el precio"
                                                ></b-form-input>
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <ValidationProvider name="Impuesto" rules="required|min:1|max:2" v-slot="{ errors, valid }">
                                        <b-form-group prepend="%"
                                            label="Porcentaje Impuesto:">
                                            <b-form-input
                                                v-model="update.porcentaje_impuesto"
                                                type="number"
                                                autocomplete="off"
                                                required
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                placeholder="Ingrese el porcentaje de impuesto"
                                                ></b-form-input>
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <ValidationProvider name="código de barras" v-slot="{ errors, valid }">
                                        <b-form-group 
                                            label="Código de Barras:">
                                            <b-form-input
                                                v-model="update.codigo_barras"
                                                type="text"
                                                autocomplete="off"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                placeholder="Ingrese el código de barras"
                                                ></b-form-input>
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="4" v-if="opcionExistencia === 1">
                                    <ValidationProvider name="Existencia" rules="numeric" v-slot="{ errors, valid }">
                                        <b-form-group 
                                            label="Existencia:">
                                            <b-form-input
                                                v-model="update.existencia"
                                                type="number"
                                                autocomplete="off"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                placeholder="Ingrese la cantidad de existencia"
                                                ></b-form-input>
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <b-form-group 
                                        label="Estado:"
                                        label-for="status">
                                        <b-row cl>
                                        <b-form-checkbox v-model="update.status" name="status" switch class="ml-3" />
                                        <span v-if="update.status === true">Activo</span>
                                        <span v-else>Inactivo</span>
                                        </b-row>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="12">
                                    <vue-editor v-model="update.descripcion"></vue-editor>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12">
                                    <b-button variant="danger" class="mr-2" @click.prevent="back">
                                        Cancelar
                                    </b-button>
                                    <b-button variant="success" :disabled="invalid" type="submit">
                                        Actualizar
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-form>
                    </ValidationObserver>    
                </b-tab>
                <b-tab title="Atributos">
                    <b-row>
                        <b-col cols="12" md="6" v-for="(item, index) in attributesList" :key="index">
                            <b-form-group 
                                :label="item.nombre">
                                <b-form-select v-if="item.tipo === 'Seleccion'"
                                    v-model="item.selected.id"
                                    :options="item.active_atributos_valor"
                                    value-field="id"
                                    text-field="valor"
                                    >
                                    <template #first>
                                        <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                    </template>
                                </b-form-select>
                                <b-form-input v-else
                                    v-model="item.selected.valor"
                                    type="text"
                                    autocomplete="off"
                                    placeholder="Ingrese texto"
                                    ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-button variant="danger" class="mr-2" @click.prevent="back">
                                Cancelar
                            </b-button>
                            <b-button variant="success" @click.prevent="saveItemAttributesData(attributesList)" >
                                Guardar
                            </b-button>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
        </b-card-text>
        <ChangeCategoryModalConfirm
            :openModal="changeCategoryConfirmModal"
            :removedCategoriesList="removedCategoriesList"
            @close-modal="cancelChangeCategory()"
            @confirm-modal="confirmChangeAttributesList()"
        />
    </b-card>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { mapMutations } from 'vuex'
import ChangeCategoryModalConfirm from '../components/ChangeCategoryModalConfirm.vue'
export default {
    data(){
        return{
            errors: "",
            update: {
                codigo: '',
                nombre: '',
                categoria_id: '',
                status: false
            },
            categoriesList: [],
            removedCategoriesList: [],
            imagen: null,
            opcionExistencia: "",
            attributesList: [],
            newAttributesList: [],
            changeCategoryConfirmModal: false,
        }
    },
    components: {
        VueEditor,
        ChangeCategoryModalConfirm
    },
    created(){
        this.getCategoriesList();
        this.getConfiguracion();
        this.getItemData();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getItemData(){
            this.setLoading(true)
            await this.$conectar.post('/empresa/items/get-item-inventory-data', {id: this.$route.params.id})
            .then(response =>{
                this.update = response.data.itemEmpresaData;
                this.attributesList = response.data.attributesOfItem;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async updatePriceList(){
            this.setLoading(true)
            this.errors = "";
            let formData = new FormData();
            formData.append('imagen', this.imagen);
            for(let element in this.update){
                if(this.update[element] !== 'undefined'){
                    formData.append(element, this.update[element]);
                }
            }
            await this.$conectar.post('/empresa/items/save-item-inventory', formData, {
                headers: {
                'Content-Type': 'multipart/form-data'
                }
            })
            .then(response =>{
                if(response.data.errors){
                    this.errors = response.data.errors;
                }
                if(response.data.error === false){
                    this.$root.$bvToast.toast('Se actualizo correctamente el item', {
                            title: "Respuesta del servidor",
                            variant: "success",
                            solid: true
                    })
                    this.$router.push({ name: 'GetItemsListEmpresa' });
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast('Parece que hubo un error en el servidor', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },
        back(){
            this.$router.go(-1);
        },
        async getConfiguracion(){
            this.setLoading(true)
            await this.$conectar.post('configuracion/get-configuration')
            .then(response =>{
                if(response.data.error == false){
                    this.opcionExistencia = response.data.configuracion.opcionExistencia;
                }
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getCategoriesList(){
            this.setLoading(true)
            await this.$conectar.post('/empresa/items/get-available-categories-list')
            .then(response =>{
                this.categoriesList = response.data.availableCategoriesList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getAttributesListOFCategory(category_id){
            this.removedCategoriesList = [];
            this.setLoading(true)
            await this.$conectar.post('/empresa/items/get-attributes-list-category', {category_id: category_id, id: this.$route.params.id})
            .then(response =>{
                this.newAttributesList = response.data.categoryData.currentAttributes;
                for (let key in this.attributesList) {
                    if(!this.newAttributesList.some(e => e.id === this.attributesList[key].id)){
                        this.removedCategoriesList.push(this.attributesList[key]); 
                    }
                }
                if(this.removedCategoriesList.length > 0){
                    this.changeCategoryConfirmModal = true;
                }else{
                    this.attributesList = this.newAttributesList;
                }
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async saveItemAttributesData(){
            this.setLoading(true)
            let data = {
                item_id: this.$route.params.id,
                attributesList: this.attributesList,
            }
            await this.$conectar.post('/empresa/items/save-item-attributes-data', data)
            .then(response =>{
                if(response.data.error === false){
                    this.$root.$bvToast.toast('Se guardo correctamente los atributos del item', {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast('Parece que hubo un error en el servidor', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },
        cancelChangeCategory(){
            this.changeCategoryConfirmModal = false;
            this.update.categoria_id = null;
        },
        confirmChangeAttributesList(){
            this.attributesList = this.newAttributesList;
            this.changeCategoryConfirmModal = false;
        },
    }
}
</script>